// jshint module: true

import Component from './../../assets/scripts/component/component';
import sleep from './../../assets/scripts/modules/sleep';

const component = 'menu';
const selector = `.${component}`;

class Menu extends Component {

  constructor(name, element, options) {
    super(name, element, options);
  }

  init() {

    this.overlay = document.getElementById('menu-overlay');
    this.menuLinks = this.element.querySelectorAll('.menu__list--long > .menu__link[href]');

    if (this.overlay) {
      const overlayButtons = document.querySelectorAll('a[href="#menu-overlay"]');

      for (const overlayButton of overlayButtons) {
        overlayButton.addEventListener('click', event => this.toggleOverlay(event), false);
      }

      this.overlay.addEventListener('click', event => this.toggleOverlay(event, true), false);
    }

    window.addEventListener('page-change', event => this.onPageChange(event), false);

  }

  toggleOverlay(event, force = false) {

    if (force || this.overlay.classList.contains('is-target')) {
      document.documentElement.classList.remove('prevent-scrolling');
      this.overlay.classList.remove('is-target');
    } else {
      document.documentElement.classList.add('prevent-scrolling');
      this.overlay.classList.add('is-target');
    }

    event.preventDefault();
    event.stopPropagation();

  }

  async onPageChange(event) {

    document.documentElement.classList.remove('prevent-scrolling');
    document.scrollingElement.scrollTop = 0;

    this.overlay.classList.remove('is-target');

    if (event.detail) {
      this.setActiveMenuItem(event.detail.id, event.detail.getAttribute('data-parent'));
      this.setOverlayActiveText();
      await sleep(300);
    }

  }

  setActiveMenuItem(name, parent) {

    if (!this.menuLinks) {
      return;
    }

    for (const menuLink of this.menuLinks) {
      menuLink.classList.remove('menu__link--active');

      if (menuLink.href) {
        if (parent && menuLink.href.indexOf(`#${parent}`) !== -1) {
          menuLink.classList.add('menu__link--active');
        } else if (menuLink.href.indexOf(`#${name}`) !== -1) {
          menuLink.classList.add('menu__link--active');
        }
      }
    }

  }

  setOverlayActiveText() {

    if (!this.overlay) {
      return;
    }

    const menuLink = this.element.querySelector('.menu__link--active');
    const targetLinks = this.element.querySelectorAll('.menu__list--short > .menu__link[href="#menu-overlay"], .menu__overlay-link > .menu__link');

    if (!menuLink || !targetLinks.length) {
      return;
    }

    const text = menuLink.getAttribute('data-text') || menuLink.innerText;

    for (const targetLink of targetLinks) {
      targetLink.innerText = text;
    }

  }

}

for (const element of document.querySelectorAll(selector)) {
  element.instance = new Menu(component, element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/menu/menu.js